import { useTranslation } from 'react-i18next';

import {
  AboutSectionContainer,
  Left,
  Right,
  SkillImage,
  SkillItem,
} from './styles';

import react from '../../../assets/icons/techs/React.svg';
import typescript from '../../../assets/icons/techs/typescript.svg';
import styledComponents from '../../../assets/icons/techs/styled-components.svg';
import vtex from '../../../assets/icons/techs/vtex.svg';
import javascript from '../../../assets/icons/techs/javascript.svg';
import node from '../../../assets/icons/techs/nodejs.svg';
import docker from '../../../assets/icons/techs/docker.svg';
import sass from '../../../assets/icons/techs/sass.svg';
import angular from '../../../assets/icons/techs/angular.svg';
import vue from '../../../assets/icons/techs/vue.svg';

import ProgressBar from './componentsAbout/progressBar';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <AboutSectionContainer>
      <div className="content" id="#about">
        <Left>
          <h2 className="title">{t('about_title')}</h2>

          <p>{t('about_me_text1')}</p>
          <p>{t('about_me_text2')}</p>
          <p>{t('about_me_text3')}</p>
          <p>{t('about_me_text4')}</p>
          <p>{t('about_me_text5')}</p>
          <p>{t('about_me_text6')}</p>
        </Left>
        <Right>
          <h2 className="title">{t('personal_skills_title')}</h2>
          <SkillItem>
            <SkillImage src={react} alt="react" />
            <ProgressBar percentage={80} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={javascript} alt="javascript" />
            <ProgressBar percentage={80} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={typescript} alt="typescript" />
            <ProgressBar percentage={90} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={vtex} alt="vtex" />
            <ProgressBar percentage={80} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={styledComponents} alt="styledComponents" />
            <ProgressBar percentage={90} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={node} alt="nodeJS" />
            <ProgressBar percentage={70} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={docker} alt="docker" />
            <ProgressBar percentage={60} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={sass} alt="sass" />
            <ProgressBar percentage={99} />
          </SkillItem>
          <SkillItem>
            <SkillImage src={angular} alt="angular" />
            <ProgressBar percentage={60} />
          </SkillItem>
          <SkillItem>
            <SkillImage
              src={vue}
              alt="vue"
              style={{
                paddingTop: 13,
              }}
            />
            <ProgressBar percentage={60} />
          </SkillItem>
        </Right>
      </div>
    </AboutSectionContainer>
  );
}
